'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialLinkedinCircular = function TiSocialLinkedinCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.7 25.5h-2.6v-8.7h2.6v8.7z m-1.3-9.8c-1 0-1.5-0.4-1.5-1.3 0-0.4 0.2-0.7 0.5-1 0.2-0.2 0.6-0.3 1-0.3 0.9 0 1.4 0.4 1.4 1.3s-0.4 1.3-1.4 1.3z m11.2 9.8h-2.7v-4.8c0-1.3-0.5-1.9-1.3-1.9-0.7 0-1.2 0.3-1.4 1-0.1 0.1-0.1 0.4-0.1 0.7v5h-2.8v-5.9c0-1.3 0-2.2 0-2.8h2.3l0.2 1.2c0.6-0.9 1.5-1.4 2.7-1.4 0.9 0 1.7 0.3 2.3 1 0.5 0.6 0.8 1.6 0.8 2.8v5.1z m-6.6 9.5c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z m0-26.7c-6.4 0-11.7 5.3-11.7 11.7s5.3 11.7 11.7 11.7 11.7-5.3 11.7-11.7-5.3-11.7-11.7-11.7z' })
        )
    );
};

exports.default = TiSocialLinkedinCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-linkedin-circular.js
// module id = 2183
// module chunks = 0